import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { FaBriefcase, FaUserTie } from "react-icons/fa";
import AjoutContratFacultatifPageModal from "pages/audit complet/situation professionnelle/modules/ajout contrat facultatif modal";
import "../../../app/settings/settings.css";
import InfoMessage from "components/ui/controls/info-message/info-message";

function ContratsFacultatif(props) {
  const context = useContext(AppContext);

  return (
    <>
      <Column pad fill>
        <CardBox>
          <Column fill>
            {context.state.TypeSimulation === "Audit prévoyance" ? (
              <Row>
                <div className="dossier-header">
                  <div className="dossier-header-icon">
                    <FaBriefcase style={{ fontSize: "14px", color: "#6b7280" }} />
                  </div>
                  <h3 className="dossier-header-title">Contrats souscrits pour {context.state.Prenom}</h3>
                </div>
              </Row>
            ) : (
              <>
                <Row>
                  {context.state.TypeSimulation === "Audit rémunération" ? (
                    <InfoMessage
                      text={
                        <>
                          Dans cet onglet, vous devez uniquement ajouter les contrats <b>souscrits par l'entreprise étudiée</b> au profit du dirigeant.
                        </>
                      }
                    />
                  ) : (
                    <InfoMessage
                      text={
                        <>
                          Dans cet onglet, vous devez uniquement ajouter les contrats <b>souscrits par l'entreprise étudiée</b> au profit du dirigeant et éventuellement de son conjoint. Les
                          contrats d'épargne retraite souscrits à titre personnel doivent être saisis dans l'onglet retraite.
                        </>
                      }
                    />
                  )}
                </Row>
                <Row tpad>
                  {context.state.TypeSimulation === "Audit rémunération" ? (
                    <div className="dossier-header">
                      <div className="dossier-header-icon">
                        <FaBriefcase style={{ fontSize: "14px", color: "#6b7280" }} />
                      </div>
                      <h3 className="dossier-header-title">Contrats souscrits par l'entreprise</h3>
                    </div>
                  ) : (
                    <div className="dossier-header">
                      <div className="dossier-header-icon">
                        <FaBriefcase style={{ fontSize: "14px", color: "#6b7280" }} />
                      </div>
                      <h3 className="dossier-header-title">
                        Contrats souscrits par {context.state.IdentiteEntreprise} pour {context.state["Prenom" + props.ClientConjoint]}
                      </h3>
                    </div>
                  )}
                </Row>
              </>
            )}
            <AjoutContratFacultatifPageModal
              Outil={props.Outil}
              AccessRemExpress={"AccessRemExpress" in props ? true : false}
              Statut={props.Statut}
              ClientConjoint={props.ClientConjoint}
              CliConj={props.ClientConjoint}
            />
            {context.state.InclureConjoint && context.state.StatutConjoint !== "Aucun" && (
              <>
                <Row tpad style={{ marginTop: "90px" }}>
                  <div className="dossier-header">
                    <div className="dossier-header-icon">
                      <FaUserTie style={{ fontSize: "14px", color: "#6b7280" }} />
                    </div>
                    <h3 className="dossier-header-title">
                      Contrats souscrits par {context.state.IdentiteEntreprise} pour {context.state.PrenomConjoint}
                    </h3>
                  </div>
                </Row>

                <AjoutContratFacultatifPageModal Outil={props.Outil} AccessRemExpress={false} Statut={context.state.StatutConjoint} ClientConjoint="Conjoint" CliConj="ConjointAssocie" />
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
}

export default ContratsFacultatif;
